<template>
  <v-badge
    :color="getActionItemColor(actionItem.completed)"
    :content="actionItem.count | no_decimal"
    overlap
  >
    <avatar
      :icon="getActionItemIcon(actionItem.completed)"
      :size="55"
      iconColor="secondarytext"
      borderColor="secondarytext"
      borderStyle="1"
      :iconSize="30"
    >
      <template v-slot:tooltip>
        {{ getActionItemName(actionItem.completed) }}
      </template>
    </avatar>
  </v-badge>
</template>

<script>
import actionItems from "@/helpers/mixins/actionItems";
export default {
  name: "ActionItemAvatar",
  mixins: [actionItems],
  props: { actionItem: { type: Object } },
  computed: {}
};
</script>
